import React, { useMemo, useState } from 'react'
import { Accordion, List } from 'antd-mobile'
import { getFaqListAll } from '@feedback/services/index'
import { useRequest } from 'ahooks'
import { reportFn } from '@feedback/utils/util'
import './App.scss'
interface Props {
  history: any
}

const App: React.FC<Props> = ({ history }) => {
  const { data = {} } = useRequest(() => getFaqListAll())
  const { data: listObject = {} } = data
  const [questionList, setQuestionList] = useState<any[]>([])
  const toDetail = (faq_id: string) => {
    history.push(`/v1/questionDetail?faq_id=${faq_id}`)
  }
  useMemo(() => {
    const arr = Object.values(listObject)
    arr.length && setQuestionList(arr)
  }, [listObject])
  // 递归处理
  const renderList = (objList: any) => {
    if (!Array.isArray(objList)) {
      return null
    }
    return (
      <Accordion>
        {objList.map((item: any) => (
          <Accordion.Panel
            header={item.name}
            className='first-panel'
            key={item._id}
          >
            {Array.isArray(item.children) && renderList(item.children)}
            {Array.isArray(item.list) && (
              <List>
                {item.list.map((sItem: any) => (
                  <List.Item
                    key={sItem._id}
                    onClick={() => {
                      reportFn({ parm1: 2, parm2: 1, parm6: sItem._id })
                      toDetail(sItem._id)
                    }}
                  >
                    {`     ${sItem.question}`}
                  </List.Item>
                ))}
              </List>
            )}
          </Accordion.Panel>
        ))}
      </Accordion>
    )
  }
  return (
    <div className='p-question-list'>
      <div className='c-question-panel'>{renderList(questionList)}</div>
    </div>
  )
}

export default App
